import utils from './_utils.js';

const BurgerNav = {

	"elements": {},

	"burgerVisClass": 'masthead--expanded',

	"parentNavVisClass": 'masthead__nav-parent--expanded',

	"langMenuVisClass": 'masthead__lang-menu--expanded',

	inMobileState()
	{
		const mqList = window.matchMedia("(max-width: 700px)");
		return mqList.matches;
	},

	bind()
	{
		// toggle burger
		this.elements.burger.addEventListener('click', (e) => {
			e.preventDefault();
			this.toggleBurger();
		});

		// toggle mobile primary nav
		this.elements.nav.addEventListener('click', (e) =>
		{
			// will not be null if not display:none
			const burgerIsVisible = this.elements.burger.offsetParent !== null;

			if( burgerIsVisible )
			{
				const parent = e.target.parentNode;

				if(parent.classList.contains('js-nav-parent'))
				{
					e.preventDefault();
					parent.classList.toggle(this.parentNavVisClass);
				}
			}
		});

		// toggle language menu
		if( this.elements.langLabel ) {
			this.elements.langLabel.addEventListener('click', (e) =>
			{
				e.preventDefault();
				this.toggleLangMenu();
			});
		}
	},

	cacheDom()
	{
		this.elements.masthead = document.querySelector('.js-masthead');
		this.elements.burger = this.elements.masthead.querySelector('.js-burger');
		this.elements.burgerOpenIcon = this.elements.masthead.querySelector('.js-burger-open');
		this.elements.burgerCloseIcon = this.elements.masthead.querySelector('.js-burger-close');
		this.elements.langLabel = this.elements.masthead.querySelector('.js-lang-label');
		this.elements.langMenu = this.elements.masthead.querySelector('.js-lang-menu');

		this.elements.nav = this.elements.masthead.querySelector('.js-masthead-nav');
		this.elements.parentExpanders = this.elements.masthead.querySelector('.js-nav-parent');
	},

	toggleBurger()
	{
		this.elements.masthead.classList.toggle(this.burgerVisClass);
	},

	toggleLangMenu()
	{
		this.elements.langMenu.classList.toggle(this.langMenuVisClass);
	},

	init()
	{
		this.cacheDom();
		this.bind();
	}
};

export default BurgerNav;